import { Flex, Text, Button } from "@scaleaq/sui-react";
import { useTranslation } from "react-i18next";
import { Icon, StatusCard } from "src/components";
import { TRANSLATION } from "src/models/constants";
import styles from "./ErrorBlock.module.scss";

export type ErrorBlockProps = {
	title?: string;
	description?: string;
	errorCode?: string;
};

export const ErrorBlock = (props: ErrorBlockProps) => {
	const { t } = useTranslation([TRANSLATION.COMMON]);
	const {
		title = t("COMMON:error.title"),
		description = t("COMMON:error.message"),
		errorCode,
	} = props;

	return (
		<Flex.Column display="flex" alignment="center" className={styles["error-block"]}>
			<img src={"src/assets/error-background.svg"} alt="Error background" className={styles.image} />
			<StatusCard
				color="critical"
				icon={<Icon size="large" name="LargeDanger" />}
				title={title}
				description={description}
				className={styles.card}
				errorCode={errorCode}
				childrenWithin={
					<Flex.Column alignment="top-left" gap="2xlarge" width="100%">
						<Text.Body.Medium weight="semi-bold" color="secondary">
							{t("COMMON:error.navDescription")}
						</Text.Body.Medium>
						<Flex.Row alignItems="flex-start" justifyContent="space-between" width="100%" gap={"large"}>
							<Flex.Row alignment="center-left" gap={"large"}>
								<Button color={"neutral"} size="large" variant={"soft"}>
									{t("COMMON:error.emailText")}
								</Button>
								<Button color={"neutral"} variant={"soft"} size="large">
									{t("COMMON:error.numberText")}
								</Button>
							</Flex.Row>
							<Button
								tailIcon={<Icon name="LargeHistoricalBrowser" />}
								variant={"solid"}
								size="large"
								onClick={() => {
									window.location.reload();
								}}
							>
								{t("COMMON:error.refreshText")}
							</Button>
						</Flex.Row>
					</Flex.Column>
				}
			/>
		</Flex.Column>
	);
};
